import * as Mod1 from "./discourse/components/edit-category-group";
import * as Mod2 from "./discourse/components/frl-category-group";
import * as Mod3 from "./discourse/components/frl-clock";
import * as Mod4 from "./discourse/components/frl-composer-info";
import * as Mod5 from "./discourse/components/frl-debug-modal";
import * as Mod6 from "./discourse/components/frl-edit-group";
import * as Mod7 from "./discourse/connectors/composer-fields/flexible-rate-limits.gjs";
import * as Mod8 from "./discourse/controllers/admin-plugins/flexible-rate-limits";
import * as Mod9 from "./discourse/flexible-rate-limits-route-map";
import * as Mod10 from "./discourse/lib/category-groups";
import * as Mod11 from "./discourse/models/category-group";
import * as Mod12 from "./discourse/routes/admin-plugins/flexible-rate-limits";
import * as Mod13 from "./discourse/templates/admin-plugins/flexible-rate-limits";
const compatModules = {
  "discourse/components/edit-category-group": Mod1,
  "discourse/components/frl-category-group": Mod2,
  "discourse/components/frl-clock": Mod3,
  "discourse/components/frl-composer-info": Mod4,
  "discourse/components/frl-debug-modal": Mod5,
  "discourse/components/frl-edit-group": Mod6,
  "discourse/connectors/composer-fields/flexible-rate-limits": Mod7,
  "discourse/controllers/admin-plugins/flexible-rate-limits": Mod8,
  "discourse/flexible-rate-limits-route-map": Mod9,
  "discourse/lib/category-groups": Mod10,
  "discourse/models/category-group": Mod11,
  "discourse/routes/admin-plugins/flexible-rate-limits": Mod12,
  "discourse/templates/admin-plugins/flexible-rate-limits": Mod13,
};
export default compatModules;
